import db, { storage } from './firebase';
import { v4 as uuidv4 } from 'uuid';

export const CreateChemistOrderDocument = async (details) => {
    // get the reference to the Firestore document
    const batch = db.batch();
    const uniqueId = uuidv4();
    const docRef = db.collection('SupplyOrder').doc();

    //create user object
    details.uniqueId = uniqueId;
    details.SupplyOrderPostedDateTime = new Date();

    // write to Cloud Firestore
    const collectionRef = await db.collection('SupplyOrder').doc();
    batch.set(collectionRef, details);
    batch.commit().then(() => {
        return true;
    }).catch((error)=> {
        return false
    });
}

export const getSupplyOrderDocumentWithUserId = async (userId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('SupplyOrder').where("userId","==", userId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getSupplyOrderDocumentWithUniqueId = async (uniqueId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('SupplyOrder').where("uniqueId", "==", uniqueId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getSupplyOrderDetails = async (uniqueId) => {
    // get the reference to the Firestore document
    let product = null;
    let retailer = null;
    const productSnapshot = await db.collection('SupplyOrder').where("uniqueId", "==", uniqueId).get()
    productSnapshot.docs.map(doc => {
        product = doc.data()
    });

    const employerSnapshot = await db.collection('Users').where("uid", "==", product.userId).get()
    employerSnapshot.docs.map(doc => {
        retailer = doc.data()
    });
    return {
        product: product,
        retailer: retailer
    }
}

export const getAllUsersDocument = async () => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Users').get()
    return snapshot.docs.map(doc => doc.data());
}

export const getAllChemistUsersDocument = async () => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Users').where("userRole", "==", "Chemist").get()
    return snapshot.docs.map(doc => doc.data());
}

export const getAllSupplyOrderDocument = async () => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('SupplyOrder').get()
    const supplyOrders = snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));

    // Fetch user data for each SupplyOrder
    const ordersWithUsers = await Promise.all(
        supplyOrders.map(async (order) => {
          const userSnapshot = await db.collection('Users').doc(order.userId).get();
          const userData = userSnapshot.exists ? userSnapshot.data() : null;
          return {
            ...order,
            user: userData, // Attach user data
          };
        })
    );

    return ordersWithUsers;
}

export const getTodaySupplyOrderDocument = async () => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('SupplyOrder').get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getTodayAvailableSupplyOrderDocument = async () => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('SupplyOrder').where("IsAvailable", "==", false).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getTodayWholesalerAvailableSupplyOrderDocument = async (WholesalerId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('SupplyOrder').where("WholesalerId", "==", WholesalerId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const updateSupplyOrderDocument = async (product) => {
    const docRef = db.doc(`/SupplyOrder/${product._id}`);
    return docRef.update(product);
}

export const createExtraMedicineDocument = async (details) => {
    // get the reference to the Firestore document
    const batch = db.batch();
    const uniqueId = uuidv4();
    const docRef = db.collection('ExtraMedicine').doc();

    //create user object
    details.uniqueId = uniqueId;
    details.SupplyOrderPostedDateTime = new Date();

    // write to Cloud Firestore
    const collectionRef = await db.collection('ExtraMedicine').doc();
    batch.set(collectionRef, details);
    batch.commit().then(() => {
        return true;
    }).catch((error)=> {
        return false
    });
}

export const getExtraMedicineForSupply = async () => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('ExtraMedicine').get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const deleteOrderMedicineForSupply = async (_id) => {
    try {
        await db.collection('SupplyOrder').doc(_id).delete();
        console.log(`Document with ID ${_id} has been deleted.`);
    } catch (error) {
        console.error("Error deleting document: ", error);
    }
}

export const deleteExtraMedicineForSupply = async (_id) => {
    try {
        await db.collection('ExtraMedicine').doc(_id).delete();
        console.log(`Document with ID ${_id} has been deleted.`);
    } catch (error) {
        console.error("Error deleting document: ", error);
    }
}